module.exports = __webpack_public_path__ + "static/media/1025163.79388cbc.jpg";